import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import LandingPage from "@/pages/LandingPage";
import ScanPage from "@/pages/ScanPage";
import RadarPWA from "@/pages/RadarPWA";
import GuideVirtualPage from "@/pages/GuideVirtualPage";
import MerchantLogin from "@/pages/MerchantLogin";
import MerchantRegister from "@/pages/MerchantRegister";
import ForgotPassword from "@/pages/ForgotPassword";
import MerchantDashboard from "@/pages/MerchantDashboard";
import OffersPage from "@/pages/OffersPage";
import RedemptionsPage from "@/pages/RedemptionsPage";
import QRPage from "@/pages/QRPage";
import BillingPage from "@/pages/BillingPage";
import DesignPage from "@/pages/DesignPage";
import SalesAIPage from "@/pages/SalesAIPage";
import ProfilePage from "@/pages/ProfilePage";
import CatalogPage from "@/pages/CatalogPage";
import AuraPage from "@/pages/AuraPage";
import ManadaPage from "@/pages/ManadaPage";
import ManadaUserPage from "@/pages/ManadaUserPage";
import AtinalePage from "@/pages/AtinalePage";
import AtinaleUserPage from "@/pages/AtinaleUserPage";
import CouponsPage from "@/pages/CouponsPage";
import CampaignsPage from "@/pages/CampaignsPage";
import CouponJoinPage from "@/pages/CouponJoinPage";
import CuponeraPage from "@/pages/CuponeraPage";
import UserHubPage from "@/pages/UserHubPage";
import UserTicketsPage, { RaffleScanPage } from "@/pages/UserTicketsPage";
import UserChatListPage, { UserChatPage } from "@/pages/UserChatPage";
import MerchantChatPage from "@/pages/MerchantChatPage";
import RafflePage from "@/pages/RafflePage";
import ReferralsPage from "@/pages/ReferralsPage";
import UserStorePage from "@/pages/UserStorePage";
import PromoterStorePage from "@/pages/PromoterStorePage";
import DemoLoginPage from "@/pages/DemoLoginPage";
import DemoSessionPage from "@/pages/DemoSessionPage";
import AdvisorAuthPage from "@/pages/AdvisorAuthPage";
import AdvisorDashboardPage from "@/pages/AdvisorDashboardPage";
import AuthCallback from "@/pages/AuthCallback";
import JoinPage from "@/pages/JoinPage";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function AppRouter() {
  const location = useLocation();
  // Emergent OAuth callback comes back with #session_id=...
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/scan" element={<ScanPage />} />
      <Route path="/join/:merchantId" element={<JoinPage />} />
      <Route path="/radar" element={<RadarPWA />} />
      <Route path="/guide" element={<GuideVirtualPage />} />
      <Route path="/login" element={<MerchantLogin />} />
      <Route path="/register" element={<MerchantRegister />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/dashboard" element={<MerchantDashboard />} />
      <Route path="/dashboard/offers" element={<OffersPage />} />
      <Route path="/dashboard/redemptions" element={<RedemptionsPage />} />
      <Route path="/dashboard/qr" element={<QRPage />} />
      <Route path="/dashboard/billing" element={<BillingPage />} />
      <Route path="/dashboard/design" element={<DesignPage />} />
      <Route path="/dashboard/sales-ai" element={<SalesAIPage />} />
      <Route path="/dashboard/aura" element={<AuraPage />} />
      <Route path="/dashboard/manada" element={<ManadaPage />} />
      <Route path="/manada" element={<ManadaUserPage />} />
      <Route path="/dashboard/atinale" element={<AtinalePage />} />
      <Route path="/juego" element={<AtinaleUserPage />} />
      <Route path="/dashboard/cupones" element={<CouponsPage />} />
      <Route path="/dashboard/campanas" element={<CampaignsPage />} />
      <Route path="/c/:merchantId" element={<CouponJoinPage />} />
      <Route path="/cuponera" element={<CuponeraPage />} />
      <Route path="/mi" element={<UserHubPage />} />
      <Route path="/mi/boletos" element={<UserTicketsPage />} />
      <Route path="/mi/chat" element={<UserChatListPage />} />
      <Route path="/mi/chat/:merchantId" element={<UserChatPage />} />
      <Route path="/s/:merchantId" element={<RaffleScanPage />} />
      <Route path="/dashboard/chat" element={<MerchantChatPage />} />
      <Route path="/dashboard/sorteo" element={<RafflePage />} />
      <Route path="/dashboard/referidos" element={<ReferralsPage />} />
      <Route path="/mi/tienda" element={<UserStorePage />} />
      <Route path="/tienda/:code" element={<PromoterStorePage />} />
      <Route path="/dashboard/catalog" element={<CatalogPage />} />
      <Route path="/dashboard/profile" element={<ProfilePage />} />
      <Route path="/legal/:doc" element={<LegalPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/demo/login" element={<DemoLoginPage />} />
      <Route path="/demo" element={<DemoSessionPage />} />
      <Route path="/asesor/login" element={<AdvisorAuthPage />} />
      <Route path="/asesor" element={<AdvisorDashboardPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#FAFAFA] text-[#0A0A0A] font-body">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
